class SearchArea

  activeClass: 'is-active'

  constructor: (@$elm, @$value) ->
    @$window     = $ window
    @$areaBox    = $ '.js-area-box'
    @$cartypeBox = $ '.js-cartype-trigger'
    @$menu       = @$areaBox.find '.js-tab-menu'
    @$tabContent = @$areaBox.find '.js-tab-wrap'
    @$tab        = @$menu.children()
    @$content    = @$tabContent.children()
    @$office     = @$tabContent.find 'dl'
    @$modal      = $ '[data-remodal-id=remodal-office]'
    @modal       = @$modal.remodal()
    @officeID    = $(document.body).data 'office-id'

    @$elm.on 'click', @open
    @$tab.on 'click', @tab
    @$office.on 'click', @select

  open: =>
    @modal.open()

  close: =>
    @modal.close()
    if window.searchStory.length > 1
      window.searchStory.push true
      setTimeout =>
        @$cartypeBox.trigger 'click'
      , 400

  tab: (event) =>
    $elm = $ event.currentTarget
    index = @$tab.index $elm
    $elm
      .addClass @activeClass
      .siblings()
      .removeClass @activeClass
    @$content
      .eq index
      .show()
      .siblings()
      .hide()

  select: (event) =>
    elm      = event.currentTarget
    $elm     = $ elm
    pref     = $elm.data 'pref'
    prefID   = $elm.data 'prefId'
    office   = $elm.data 'office'
    officeID = $elm.data 'officeId'
    @$office.removeClass @activeClass
    elm.classList.add @activeClass
    @$elm[0].value = pref
    @$elm[1].value = office
    @$value[0].value = prefID
    @$value[1].value = officeID
    @modal.close()
    @$window.trigger 'changeArea'
    @close()

  initOffice: =>
    $elm = @$office.filter "[data-office-id=#{@officeID}]"
    index = $elm.parent().index()
    @$tab
      .eq index
      .trigger 'click'
    $elm.trigger 'click'

  init: =>
    @$content
      .hide()
      .eq 0
      .show()

    if @officeID
      @initOffice()

export default SearchArea



// WEBPACK FOOTER //
// ./webpack/imports/view/search-area.coffee